module.exports = __webpack_public_path__ + "static/media/feadrImage.cf08b565.svg";